import React, { useState, useEffect, useCallback } from 'react'
import styleStudio from './styles.module.sass'
import styleFlow from './stylesFlow.module.sass'
import PlusButton from './assets/svg/plus_btn.svg';
import { Modal, Toast } from './helpers/commonUi'
import { Tooltip, Empty } from "antd";
import DeleteIcon from './assets/svg/delete.svg';
import EditIcon from './assets/svg/editIcon.svg';
import DataModalContent from './DataModalContent'
import { getAxiosInstance } from "./helpers/axois";
import Collection from './CollectionList'
import './main.sass'
import { uuid } from "./helpers/commonFunction";
import { ToastProvider } from './context/ToastContext'
import { ThemeProvider } from './context/ThemeContext';

interface Props {
    appId?: string,
    theme?: any
    versionId?: string,
    previousVersionId?: string | null,
    branchId?: string,
    deploymentId?: string
    from: string,
    token: string,
    canEdit?: any,
    canDelete?: any,
    canCreate?: any,
    canView?: any,
    setIsForbidden?: any
    appType: 'solo' | 'assisted'
}

const A8Data: React.FC<Props> = (props) => {
    const style = (props.from === 'studio') ? styleStudio : styleFlow
    // Studio RBAC changes 
    const { theme = {} } = props;
    const canEdit: any = (props.from === 'studio') ? props.canEdit : true
    const canDelete: any = (props.from === 'studio') ? props.canDelete : true

    const [createModalVisible, setCreateModalVisible] = useState<boolean>(false)
    const [editModalVisible, setEditModalVisible] = useState<boolean>(false)
    const [deleteCollectionModalVisible, setDeleteCollectionModalVisible] = useState<boolean>(false)
    const [popUpState, setPopUpState] = useState<any>({})
    const [deleteString, setDeleteString] = useState<string>('')
    const appId = props.appId
    const versionId = props.versionId
    const previousVersionId = props.previousVersionId
    const branchId = props.branchId
    const deploymentId = props.deploymentId
    const from = props.from
    const [collectionList, setCollectionList] = useState<any[]>([])
    const [deleteCollectionId, setDeleteCollectionId] = useState<string>('')
    const [selectedCollection, setSelectedCollection] = useState<any>({})
    const [previousCollectionList, setPreviousCollectionList] = useState<any>([])
    const [editData, setEditData] = useState<any>({})
    const [previousCollection, setPreviousCollection] = useState<any>({})
    const Http = getAxiosInstance(props.from, props.token)

    let createCollection: any
    let editCollection: any

    const setTheme = () => {
        const root: any = document.querySelector(":root")
        const { theme = {} } = props;
        if (root) {
            Object.keys(theme).forEach(el => root.style.setProperty("--" + el, props.theme[el]))
        }
    }
    const listPopUpContent = (record: any) => {
        return (
            <div className={style.popUpContainer}>
                {
                    canEdit &&
                    (
                        <div className={style.item} onClick={(e: any) => {
                            e.stopPropagation()

                            // fixing schema id being same on edited collections, which caused ajv validate to fail
                            record.coll_schema['$id'] = `${appId}/${versionId}/${uuid()}`

                            setEditData(record)
                            const previousMatchedCollection = previousCollectionList.filter((item: any) => item.coll_name === record.coll_name)
                            if (previousMatchedCollection.length > 0) {
                                setPreviousCollection(previousMatchedCollection[0])
                            } else {
                                setPreviousCollection({
                                    coll_schema: {
                                        properties: {}
                                    }
                                })
                            }
                            setEditModalVisible(true)
                            setPopUpState({
                                [record.coll_id]: false
                            })
                        }}>
                            <EditIcon height='18px' width='18px' />
                            <div className={style.text}>Edit</div>
                        </div>
                    )
                }
                {
                    canDelete &&
                    (
                        <div className={style.item} onClick={(e: any) => {
                            e.stopPropagation()
                            setPopUpState({
                                [record.coll_id]: false
                            })
                            setDeleteString(record.coll_name)
                            setDeleteCollectionId(record.coll_id)
                            setDeleteCollectionModalVisible(true)
                        }}>
                            <DeleteIcon height='18px' width='18px' />
                            <div className={style.text}>Delete</div>
                        </div>
                    )
                }
            </div>
        )
    }

    // const versionId = useSelector((state:any) => {
    //     return state.apps.appVersion[appId].versionId
    // })  

    const getCollections = useCallback(() => {
        (from === 'studio')
            ?
            Http.get(`/app/${appId}/collections?versionId=${versionId}`).subscribe((res: any) => {
                setCollectionList(res)
                if (res.length) {
                    Http.get(`/app/${appId}/collections?versionId=${previousVersionId}`).subscribe((data: any) => {
                        if (data.length) {
                            setPreviousCollectionList(data);
                        } else {
                            setPreviousCollection([]);
                        }
                    })
                    setSelectedCollection(res[0]);
                } else {
                    setSelectedCollection({});
                }
            }, (err: any) => {
                if (err === 'Forbidden') {
                    //RBAC changes
                    props.setIsForbidden(true)
                }
            })
            :
            Http.get(`/a8flow/${deploymentId}/collections`).subscribe((res: any) => {
                setCollectionList(res)
                if (res.length) {
                    setSelectedCollection(res[0]);
                } else {
                    setSelectedCollection({});
                }
            })
    }, [appId, versionId, deploymentId, from])
    const deleteCollection = (collectionId: string) => {
        Http.delete(`/app/${appId}/collections/${collectionId}?versionId=${versionId}&branchId=${branchId}`).subscribe(() => {
            // toastDispatch(addToast("Collection deleted successfully", "success"))
            getCollections()
        }, (_err: any) => {
            // toastDispatch(addToast("Collection deletion failed", "error"))
        })
    }

    useEffect(() => {
        setTheme()
    }, [])

    useEffect(() => {
        getCollections()
    }, [getCollections])

    const isActiveStyle = (selectedCollection: any, collection: any) => {
        if (selectedCollection) {
            if (from === 'studio') {
                return selectedCollection && selectedCollection.coll_id === collection.coll_id
            } else {
                return selectedCollection && selectedCollection.collectionName === collection.collectionName
            }
        }
    }

    return (
        <ThemeProvider
            theme={{
                primaryColor: theme.primaryColor || "#223979",
                secondaryColor: theme.secondaryColor || "#cb1e1a",
                secondaryOpacity: theme.secondaryOpacity || "#cb1e1a30",
                primaryOpacity: theme.primaryOpacity || "#22397930",
                drawerOpacityColor: theme.drawerOpacityColor || "#22397999"
            }}>
            <ToastProvider>{props.from === 'studio' || collectionList.length > 0 ?
                <div className={style.dataContainer}>
                    <div style={{ display: 'flex' }}>
                        <div className={style.dataList}>
                            <div className={style.header}>
                                {
                                    (props.from === 'studio' && props.canCreate) ?
                                        <React.Fragment>
                                            <h5 className={style.title}>CREATE COLLECTION</h5>
                                            <PlusButton style={{ color: (props.from === 'studio') ? '#0466c8' : '#CB1E1A' }} width="24px" height="24px" onClick={() => setCreateModalVisible(true)} />
                                        </React.Fragment>
                                        : <h5 className={style.title} style={{ fontSize: '16px' }}>COLLECTION LIST</h5>}
                            </div>
                            <div className={style.collectionDetails}>
                                {collectionList.map((collection: any, index) => {
                                    return (
                                        <div
                                            key={
                                                from === 'studio' ? collection.coll_id : collection.collectionName
                                            }
                                            onClick={() => {
                                                setSelectedCollection(collection)
                                            }}
                                            onContextMenu={(e) => {
                                                e.preventDefault()
                                                if (from === 'studio') {
                                                    setPopUpState({
                                                        [collection.coll_id]: true
                                                    })
                                                }
                                                // else{
                                                //     setPopUpState({
                                                //         [collection.collectionName] : true
                                                //     })
                                                // }
                                            }}
                                            className={isActiveStyle(selectedCollection, collection) ? style.selectedCollection : style.singleCollection}
                                        >
                                            <Tooltip
                                                onVisibleChange={(visible: boolean) => {
                                                    if (from === 'studio') {
                                                        setPopUpState({
                                                            [collection.coll_id]: visible
                                                        })
                                                    }
                                                    // else{
                                                    //     setPopUpState({
                                                    //         [collection.collectionName] : visible
                                                    //     })
                                                    // }
                                                }}
                                                visible={
                                                    (from === 'studio' && (props.canEdit || props.canDelete))
                                                        ?
                                                        popUpState[collection.coll_id]
                                                        :
                                                        false
                                                    // popUpState[collection.collectionName]

                                                }
                                                placement='rightTop'
                                                overlayClassName={'teamPopUp'}
                                                title={() => listPopUpContent(collection)}
                                                trigger='contextMenu'
                                                key={index}
                                            >
                                                <div className={style.collectionInfo}>
                                                    <div className={style.collectionName}
                                                        style={{
                                                            color: (isActiveStyle(selectedCollection, collection) && props.from !== 'studio')
                                                                ?
                                                                props.theme.secondaryColor : '#444444'
                                                        }}
                                                    >
                                                        {
                                                            (from === 'studio') ?
                                                                collection.coll_name || 'Name' :
                                                                collection.collectionName || 'Name'
                                                        }
                                                    </div>
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <Collection
                            canEdit={canEdit}
                            canDelete={canDelete}
                            collection={selectedCollection}
                            appId={appId}
                            versionId={versionId}
                            from={props.from}
                            token={props.token}
                        />
                    </div>
                    <Modal
                        title='CREATE COLLECTION'
                        unmountOnCancel={true}
                        footer={{
                            enable: true,
                            cancelText: 'CANCEL',
                            okText: 'CREATE',
                            onOk: () => {
                                const modalClose = createCollection && createCollection(getCollections)
                                setCreateModalVisible(modalClose)
                            }
                        }}
                        visible={createModalVisible}
                        onCancel={() => {
                            setCreateModalVisible(false)
                            // setEditMode(false)
                        }}
                        width='800px'
                        from={props.from}
                    >
                        <ToastProvider>
                            <DataModalContent
                                createCollection={(callback: any) => {
                                    createCollection = callback
                                }}
                                appId={appId}
                                versionId={versionId}
                                branchId={branchId}
                                from={props.from}
                                token={props.token}
                                appType={props.appType}
                            />
                        </ToastProvider>
                    </Modal>
                    <Modal
                        from={props.from}
                        title='EDIT COLLECTION'
                        unmountOnCancel={true}
                        footer={{
                            enable: true,
                            cancelText: 'CANCEL',
                            okText: 'SAVE',
                            onOk: () => {
                                editCollection && editCollection(getCollections)
                                setEditModalVisible(false)
                            }
                        }}
                        visible={editModalVisible}
                        onCancel={() => {
                            setEditModalVisible(false)
                        }}
                        width='800px'
                    >
                        <ToastProvider>
                            <DataModalContent
                                editCollection={(callback: any) => {
                                    editCollection = callback
                                }} editData={editData}
                                prevCollection={previousCollection}
                                appId={appId}
                                versionId={versionId}
                                branchId={branchId}
                                from={props.from}
                                token={props.token}
                                appType={props.appType}
                            />
                        </ToastProvider>
                    </Modal>
                    <Modal
                        from={props.from}
                        title='DELETE COLLECTION'
                        unmountOnCancel={true}
                        footer={{
                            enable: true,
                            cancelText: 'CANCEL',
                            okText: 'DELETE',
                            onOk: () => {
                                deleteCollection(deleteCollectionId)
                                setDeleteCollectionModalVisible(false)
                            }
                        }}
                        visible={deleteCollectionModalVisible}
                        deleteOptions={{
                            type: 'collection',
                            validateString: deleteString
                        }}
                        onCancel={() => setDeleteCollectionModalVisible(false)}
                    />
                    <Toast closeIn={3500} from={props.from} />
                </div>
                : <Empty style={{ margin: "300px" }} image={Empty.PRESENTED_IMAGE_SIMPLE} />}</ToastProvider></ThemeProvider>
    )
}


export default A8Data;
